import router from "./index";
import {set, get } from '@/utils/localStorage'
import {me} from '@/api/service';
import{partnerType} from '@/config/index'

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.matched.length === 0) {
        //如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/');
    }
    //进入登录清空之前缓存
    if (to.path == '/login') {
        localStorage.removeItem('queryData')
    }
    //拿当前参数存入缓存
    let queryData = to.query;
    let obj = Object.keys(queryData)
    if (obj.length !== 0) {
        queryData = Object.assign({}, get('queryData'), queryData);
        set("queryData", queryData);
    }

    const loginPath = [
        '/',
    ];
    if (loginPath.indexOf(to.path) !== -1) {
        next();
    }else{
        me().then((res) => {
            window.location.href = `/platform/opus/apply?partnerType=${partnerType}`
        }).catch((err) => {
            next()
        })
    }
})